// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { fetchUserActivity, checkIdleUsers, fetchAllUserActivity } from '../../user/userService';

// Selectors
import { remoteUserIdsCurrentlyViewingSelector } from '../../workspace/sharing/boardSharingUtilSelector';
import { socketConnectedSelector } from '../socket/socketConnectionSelector';
import { isGuestSelector } from '../../user/currentUserSelector';

// Constants
import { USER_IDLE_TIMEOUT_MILLISECONDS } from '../../../common/users/userConstants';
import { TIMES } from '../../../common/utils/timeUtil';

const mapStateToProps = createSelector(
    remoteUserIdsCurrentlyViewingSelector,
    socketConnectedSelector,
    isGuestSelector,
    (remoteUserIdsCurrentlyViewing, socketConnected, isGuest) => ({
        remoteUserIdsCurrentlyViewing,
        socketConnected,
        isGuest,
    }),
);

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchUserActivity: (userIds) => dispatch(fetchUserActivity(userIds)),
    dispatchFetchAllUserActivity: () => dispatch(fetchAllUserActivity()),
    dispatchCheckIdleUsers: () => dispatch(checkIdleUsers()),
});

@connect(mapStateToProps, mapDispatchToProps)
class UserActivityManager extends React.Component {
    constructor(props) {
        super(props);

        this.timeoutId = null;
    }

    componentWillMount() {
        // Check for idle users twice for every timeout interval.  That way the client can only be at most
        // 1/2 a timeout out of sync.  For example if the timeout is 10 minutes the client will be updated
        // of another user's disconnection within at least 5 minutes.
        this.idleUserCheckIntervalId = setInterval(
            this.props.dispatchCheckIdleUsers,
            USER_IDLE_TIMEOUT_MILLISECONDS / 2,
        );
    }

    componentWillReceiveProps(nextProps) {
        const {
            currentBoardId,
            remoteUserIdsCurrentlyViewing,
            dispatchFetchUserActivity,
            dispatchFetchAllUserActivity,
            socketConnected,
            isGuest,
        } = nextProps;

        // Don't load any user activity for guest users
        if (isGuest) return;

        // When we navigate to a new board that has remote users on it, get updates for their user activity
        if (currentBoardId !== this.props.currentBoardId && remoteUserIdsCurrentlyViewing.length) {
            dispatchFetchUserActivity(remoteUserIdsCurrentlyViewing);
        }

        // If we become connected again, re-fetch every user's activity
        if (socketConnected && !this.props.socketConnected) {
            if (this.timeoutId) clearTimeout(this.timeoutId);

            // Don't bombard the servers with user activity fetching
            this.timeoutId = setTimeout(() => {
                dispatchFetchAllUserActivity();
            }, Math.random() * TIMES.MINUTE);
        }
    }

    componentWillUnmount() {
        if (this.idleUserCheckIntervalId) clearInterval(this.idleUserCheckIntervalId);
    }

    render() {
        return null;
    }
}

UserActivityManager.propTypes = {
    remoteUserIdsCurrentlyViewing: PropTypes.array,
    currentBoardId: PropTypes.string,
    dispatchFetchUserActivity: PropTypes.func,
    dispatchFetchAllUserActivity: PropTypes.func,
    dispatchCheckIdleUsers: PropTypes.func,
    isGuest: PropTypes.bool,
    socketConnected: PropTypes.bool,
};

export default UserActivityManager;
